import { IColors } from './IColors';
// const affinyColors = {
//   primary: accent,
//   primaryG4: gradientEnd,
//   primaryGradient: `linear-gradient(135deg, ${accent} 0%, ${gradientEnd} 100%)`,
//   gradientSpecialOffer: `linear-gradient(135deg, ${tawnyPort} 0%, ${wineBerry} 100%)`,
//   secondary: '#4C9D9F',
//   payment: '#00D392',
//   neutralPrimary: '#545454',
//   neutralSecondary: '#A1A1A1',
//   neutralTertiary: '#EAEAEA',
//   neutralQuaternary: '#F7F7F7',
//   chivalrous: '#ff3e14',
//   egalitarian: '#ce2bb6',
//   neoRomantic: '#e89e03',
//   traditionnalist: '#633dee',
// };

const accent = '#E94268';
const gradientEnd = '#F08168';
const tawnyPort = '#76204B';
const wineBerry = '#541842';

export const colors: IColors = {
  disabled: 'rgb(199,199,199)',
  primary2: `rgb(233, 66, 104)`, // // pinky
  primaryHover: 'rgb(252, 227, 233)', // equivalent of opacity .05 by primary2
  primaryHoverContained: 'rgb(204, 58,91)', // equivalent of brightness .9

  secondary2: `rgb(76, 157, 159)`, // blue-green-ish
  secondaryHover: `rgb(229, 240, 241)`,
  secondaryHoverContained: `rgb(66, 136, 138)`,

  subscription: `rgb(0, 211, 146)`, // flash green
  subscriptionHover: `rgb(217, 248, 238)`,
  subscriptionHoverContained: `rgb(0,179,124)`,

  grey1: 'rgb(161, 161, 161)',

  apricot: '#F08168',
  apricotLight: '#F8C2B7',
  primary: '#545454',
  secondary: '#A1A1A1',
  accent,
  wineBerry,
  tawnyPort,
  accentHover: '#fef6f7',
  light: '#ffffff',
  lightHover: 'rgba(255,255,255,0.5)',
  lightTranslucent: 'rgba(255, 255, 255, 0.4)',
  gradient: `linear-gradient(135deg, ${accent} 0%, ${gradientEnd} 100%)`,
  inverted_gradient: `linear-gradient(135deg, ${gradientEnd} 0%, ${accent} 100%)`,
  gradientStart: accent,
  gradientEnd,
  gradientSpecialOffer: `linear-gradient(135deg, ${tawnyPort} 0%, ${wineBerry} 100%)`,
  gradientProfileCapture:
    'rgba(211, 102, 164, 1) linear-gradient(135deg, rgba(211, 102, 164, 1) 0%, rgba(242, 190, 85, 1) 100%)',
  gallery: '#EAEAEA',
  alabaster: '#F7F7F7',
  hippieBlue: '#4C9D9F',
  caribbeanGreen: '#00D392',
  pippin: 'rgba(233,66,104,0.15)',
  mineShaft: 'rgba(61, 61, 61, 0.7)',
  accentLight: '#F9D2DB',
  accentLighter: '#FCECEF',
  chivalrous: '#FF3E14',
  egalitarian: '#CE2BB6',
  neo_romantic: '#E89E03',
  traditionnalist: '#633DEE',
  pc_lightTranslucent: 'hsla(0, 0%, 100%, 0.3)',
  pc_darkTranslucent: 'rgba(0,0,0,.3)',
  pc_chapter_search: '#944d21',
  pc_validation_button_search: '#E2932C',
  pc_chapter_vision: '#20565E',
  pc_validation_button_vision: '#5ED4EA',
  pc_chapter_personality: '#940734',
  pc_validation_button_personality: '#5ED4EA',
  pc_chapter_tastes: '#826602',
  pc_validation_button_tastes: '#F4A500',
  pc_chapter_values: '#21544F',
  pc_validation_button_values: '#49B29F',
  pc_chapter_personal_data: '#328587',
  pc_validation_button_personal_data: '#85DCE9',
  pc_error: '#d0021b',
  ios: '#007AFF',
  android: '#0BB262',
  safetyGradientStart: '#097F99',
  safetyGradientEnd: '#5ED4E9',
  transparent_white: '#ffffff00',
  darkTranslucent: 'rgba(0, 0, 0, 0.6)',
  dark: '#000000',
};

// export const backgrounds = {
//   gradient: `linear-gradient(135deg, ${accent} 0%, ${gradientEnd} 100%)`,
//   gradientSpecialOffer: `linear-gradient(135deg, ${tawnyPort} 0%, ${wineBerry} 100%)`,
// };

// export const profileCaptureColors = {
//   search: '#944d21',
//   vision: '#20565E',
//   personality: '#940734',
//   tastes: '#826602',
//   values: '#21544F',
//   'personal-data': '#328587',
// };

// const brandColors = {
// mandy: '#EB5868',(colors.accent)
// apricot: '#F08168',(colors.apricot)
// raspberry: '#E94268',(colors.accent)
// sienna: '#ED6A68',(colors.apricot)
// wine_berry: '#4D1D40',
// tawny_port: '#6F284B',
// paradiso: '#328587',(colors.hippieBlue)
// black: '#000000',
// emperor: '#545454',(colors.primary)
// silver_chalice: '#A1A1A1',(colors.secondary)
// alabaster: '#F7F7F7',(colors.alabaster)
// gallery: '#EAEAEA',(colors.gallery)
// white: '#ffffff',(colors.light)
// warning_orange: '#FFA500', // only used for warning toasters background
// facebook: '#2553B4', // only used for facebook
// haze: '#00d392',// (colors.caribbeanGreen)
// pippin: 'rgba(233,66,104,0.15)',(colors.pippin)
// safetyGradient: {
//   start: '#097F99',
//   end: '#5ED4E9',
// },
// };
// const gradientColors = {
//   white1: 'rgba(255, 255, 255, 1)',
//   white05: 'rgba(255, 255, 255, 0.5)',
// };

// export const colorsCore = {
// ...brandColors,
// ...gradientColors,
// font_primary: brandColors.emperor, (colors.primary)
// font_secondary: brandColors.silver_chalice, (colors.secondary)
// deprecated_primary: '#D366A4',(colors.primary)
// deprecated_secondary: '#F2BE55',(colors.secondary)
// primary: brandColors.mandy,(colors.accent)
// background: brandColors.alabaster,(colors.alabaster)
// link: brandColors.mandy,(colors.accent)
// error: brandColors.black,(colors.primary)
// light_translucent: 'rgba(255, 255, 255, 0.4)',(colors.lightTranslucent)
// light_translucent_pressed: 'rgba(255, 255, 255, 0.5)',(colors.lightHover)
// dark_translucent_lighter: 'rgba(0, 0, 0, 0.2)',(colors.pc_darkTranslucent)
// dark_translucent: 'rgba(0, 0, 0, 0.4)',(colors.pc_darkTranslucent)
// dark_translucent_modal: 'rgba(0, 0, 0, 0.6)',(colors.pc_darkTranslucent)
// warning: brandColors.warning_orange, (colors.chivalrous)
// super_light: brandColors.alabaster, (colors.alabaster)
// transparent_white: 'rgba(255, 255, 255, 0)',(colors.transparents_white)
// gradients: {
// primary_gradient_start: brandColors.apricot,(colors.apricot)
// primary_gradient_medium: brandColors.mandy,(colors.accent)
// primary_gradient_end: brandColors.raspberry,(colors.accent)
// secondary_gradient_start: brandColors.wine_berry,(colors.wineBerry)
//secondary_gradient_end: brandColors.tawny_port,(colors.tawnyPort)
// },
// actionSheet: { ios: '#007AFF', android: '#0BB262' },
// };
// export const compatibilityColors = {
//   me: colors.apricot,
//   me_light: '#f8c2b7',
//   other: colors.accent,
//   other_light: '#f5a6b7',
// };
// export const personalityReportColors = {
//   chivalrous: '#ff3e14',
//   egalitarian: '#ce2bb6',
//   neoRomantic: '#e89e03',
//   traditionnalist: '#633dee',
// };

// export const formColors = {
//   error: '#f44336',
//   success: '#4caf50',
//   inputBorder: colors.primary,
//   inputLabel: colors.primary,
// };
